import {collection, limit, onSnapshot, orderBy, query} from 'firebase/firestore';
import {db} from '../../../shared/services/firebase';

export const subscribeToNotifications = (edgeId, onData, onError) => {
  const q = query(
    collection(db, 'edges', edgeId, 'notifications'),
    orderBy('timestamp', 'desc'),
    limit(10)
  );

  return onSnapshot(
    q,
    (snap) => {
      const notifications = [];
      console.log(JSON.stringify(notifications));
      
      snap.forEach((docSnap) => {
        notifications.push({id: docSnap.id, ...docSnap.data()});
      });
      onData(notifications);
    },
    (error) => {
      console.error('[configApi:subscribeToNotifications]', error);
      onError?.(error);
    }
  );
};
